import A11yDialog from 'a11y-dialog';
import { Component } from '../core/component';

export class Video extends Component {
    constructor() {
        super();
        this.selector = '[data-video]';
    }

    init() {
        let dialog = null;
        const html = document.getElementsByTagName('html')[0];
        const videoButtons = document.querySelectorAll('[data-video]');
        const contentContainer = document.getElementById('main');

        const loadVideo = (embed) => {
            if (!embed) return;

            const embedId = embed.getAttribute('data-embedid');
            const embedType = embed.getAttribute('data-embedtype');
            let src = false;

            switch (true) {
            case embedType === 'youtube':
                src = `https://www.youtube.com/embed/${embedId}?rel=0&showinfo=0&autoplay=1&enablejsapi=1`;
                break;

            case embedType === 'vimeo':
                src = `https://player.vimeo.com/video/${embedId}?autoplay=1&loop=0&autopause=0`;
                break;

            default:
                break;
            }

            if (src) {
                const iframe = document.createElement('iframe');

                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allowfullscreen', '');
                iframe.setAttribute('allow', 'autoplay; fullscreen');
                iframe.setAttribute('src', src);
                iframe.setAttribute('id', 'myIframe');

                // eslint-disable-next-line no-param-reassign
                embed.innerHTML = '';
                embed.appendChild(iframe);
            }
        };

        const stopVideo = (embed) => {
            const iframe = embed.getElementsByTagName('iframe')[0];
            if (iframe) {
                // there isn't a reliable way of controlling the vimoe video without another library.
                // instead we are just removing the src which stops the playing.
                iframe.src = '';
            }
        };

        if (!videoButtons) return;

        videoButtons.forEach((button) => {
            const target = button.getAttribute('data-a11y-dialog-show');
            const dialogElement = document.getElementById(target);

            dialog = new A11yDialog(dialogElement, contentContainer);

            // open event
            dialog.on('show', (dialogEl) => {
                const embed = dialogEl.querySelector('[data-embed]');
                html.classList.add('has-active-modal');
                if (embed) loadVideo(embed);
            });

            // close event
            dialog.on('hide', (dialogEl) => {
                const embed = dialogEl.querySelector('[data-embed]');
                html.classList.remove('has-active-modal');
                if (embed) stopVideo(embed);
            });
        });
    }
}
